import { observable, action } from 'mobx'
import { message } from 'hljd'
import { ALBUM } from '../store'
import { VR_VERIFY_SUC } from '@components/Hotel/constant'
import { isDevHost } from '@util'
import Api from '@api/hotel/albumManage'
import VrApi from '@api/hotel/vr'

export default class {
  ALBUM = ALBUM
  MODAL = {
    UPLOAD: 'uploadModal',
    ALBUM: 'albumModal'
  }

  @observable
  visible = {
    [this.MODAL.UPLOAD]: false,
    [this.MODAL.ALBUM]: false
  }

  @observable photoAlbum = null
  @observable videoAlbum = null
  @observable isUploading = false
  @observable vrPrivilege = 0 // 酒店vr权限
  @observable panoList = 0 // 全景列表

  @action
  triggerModal = modal => {
    this.visible[modal] = !this.visible[modal]
  }

  @action
  uploadedVideo = video => {
    this.triggerModal(this.MODAL.UPLOAD)

    const coverInfo = {
      origin: video.path,
      cover_path: video.cover_path,
      persistent_id: video.persistent_id
    }

    return coverInfo
  }

  @action
  getAlbumInfo = async type => {
    // 获取图片
    const { data, msg, success } = await Api.getAlbumPassPhotos(type)
    if (!success) {
      return message.error(msg)
    }

    if (!data) {
      return
    }

    const { photo, video } = data
    if (!photo && !video) {
      return
    }

    type == ALBUM.PHOTO ? (this.photoAlbum = photo) : (this.videoAlbum = video)
  }

  @action
  uploadVideoError = (e, info) => {
    console.log('video err:', e, info)
    if (info.code === -600) {
      message.error('视频大小不能大于100M')
    }
  }

  @action
  triggerUploading = (isUploading = false) => {
    console.log('before upload', isUploading)
    this.isUploading = !!isUploading
  }

  @action
  uploadedImageError = () => {
    this.triggerUploading()
  }

  @action
  getPrivilege = async () => {
    // 酒店vr权限 1有 0无
    const {
      data: { hotelVr }
    } = await VrApi.getMerchantPrivilege()
    this.vrPrivilege = !!+hotelVr
  }

  @action
  getPanoList = async () => {
    const { data } = await VrApi.getPanoList({
      page: 1,
      per_page: 2000
    })
    this.panoList = data.list
      .filter(state => state.status == VR_VERIFY_SUC)
      .map(item => ({
        ...item,
        status: `${item.status}`
      }))
  }

  @action
  selectVrCover = (i, changeCover, pano_id) => {
    const { id, material_id, cover } = this.panoList[i]
    if (this.panoList[i].status === VR_VERIFY_SUC) {
      if (this.panoList[i].id == pano_id) {
        changeCover('vr', {})
      } else {
        changeCover('vr', {
          pano_id: id,
          id: material_id,
          cover_path: cover,
          path: `https://${
            isDevHost() ? 'static-dev' : 'static'
          }.hunliji.com/hlj-hotel-vr-pages/index.html?id=${id}`,
          width: 1010,
          height: 568
        })
      }
    }
  }
}
